export default class MetaInfo {

  id = null;
  name = "";
  color = "";

  constructor() {
  }
}
